import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import useFetch from "../../hooks/useFetch";

import { formatSongTitle } from "./formatSongTitle";

function DownloadAction({ item }: any) {

  const { fetchData: fetchDownloadUrl } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/events/music/signedurl/${item.id}`,
    method: "POST",
  });

  const handleDownload = async () => {
    try {
      console.log("DownloadAction: Fetching fresh download URL");

      const response = await fetchDownloadUrl({ song_id: item.id, s3_file_key: item.s3_file_key, action:"Download", fileName: formatSongTitle(item.song_title, item.performance?.entry_number ?? 0) });
      const finalUrl = response?.data?.s3downloadurl;

      if (!finalUrl) {
        console.error("DownloadAction: No download URL returned");
        return;
      }

      const link = document.createElement("a");
      link.href = finalUrl;
      link.download = item.fileName || "song.mp3";
      link.click();
    } catch (error) {
      console.error("DownloadAction: Failed to get download URL", error);
    }
  };

  return (
    <FileDownloadOutlinedIcon
      className="music-icon download"
      onClick={handleDownload}
      titleAccess="Download"
      style={{ cursor: "pointer" }}
    />
  );
}

export default DownloadAction;